'use server'

import { apiRequest, ApiResponse } from '../request'

export type ChartOfAccountsType = 'ASSET' | 'LIABILITY' | 'EQUITY' | 'INCOME' | 'EXPENSE'

export interface ChartOfAccountsItem {
    id: number
    code: string
    title: string
    type: ChartOfAccountsType
    isDre: boolean
    active: boolean
    parentId: number | null
    parent?: { id: number; code: string; title: string } | null
    children?: ChartOfAccountsItem[]
    _count?: { children: number }
    companyId: number
    createdAt: string
    updatedAt: string
}

export interface CreateChartOfAccountsData {
    code?: string
    title: string
    type: ChartOfAccountsType
    parentId?: number | null
    isDre?: boolean
    active?: boolean
}

export interface UpdateChartOfAccountsData extends Partial<CreateChartOfAccountsData> {}

const BASE = 'financial/chart-of-accounts'

export async function getNextCode(parentId?: number | null): Promise<ApiResponse<{ code: string }>> {
    const params: any = {}
    if (parentId) params.parentId = parentId
    return apiRequest<{ code: string }>(`${BASE}/next-code`, { params })
}

export async function getChartOfAccounts(params?: {
    type?: ChartOfAccountsType
}): Promise<ApiResponse<ChartOfAccountsItem[]>> {
    return apiRequest<ChartOfAccountsItem[]>(BASE, { params: params || {} })
}

export async function getChartOfAccountsTree(params?: {
    type?: ChartOfAccountsType
}): Promise<ApiResponse<ChartOfAccountsItem[]>> {
    return apiRequest<ChartOfAccountsItem[]>(`${BASE}/tree`, { params: params || {} })
}

export async function getChartOfAccountsItem(id: number): Promise<ApiResponse<ChartOfAccountsItem>> {
    return apiRequest<ChartOfAccountsItem>(`${BASE}/${id}`, {})
}

export async function createChartOfAccounts(data: CreateChartOfAccountsData): Promise<ApiResponse<ChartOfAccountsItem>> {
    return apiRequest<ChartOfAccountsItem>(BASE, { data }, 'post')
}

export async function updateChartOfAccounts(id: number, data: UpdateChartOfAccountsData): Promise<ApiResponse<ChartOfAccountsItem>> {
    return apiRequest<ChartOfAccountsItem>(`${BASE}/${id}`, { data }, 'patch')
}

export async function deleteChartOfAccounts(id: number): Promise<ApiResponse<void>> {
    return apiRequest<void>(`${BASE}/${id}`, {}, 'delete')
}

export async function getChartOfAccountsChildren(parentId: number): Promise<ApiResponse<ChartOfAccountsItem[]>> {
    return apiRequest<ChartOfAccountsItem[]>(`${BASE}/children/${parentId}`, {})
}

export async function searchChartOfAccounts(query: string, type?: ChartOfAccountsType): Promise<ApiResponse<ChartOfAccountsItem[]>> {
    const params: any = { q: query }
    if (type) params.type = type
    return apiRequest<ChartOfAccountsItem[]>(`${BASE}/search`, { params })
}
